import React from 'react';
import _ from 'lodash';
import ProductUniqueOption from "./ProductUniqueOption";
import {getProductUniquesList} from "../models/LloydItem";
import {camelOrSnakeField} from "../../../ReduxStore/Helpers/transformObject";

/*
 * ProductUniquePicker - for one cart item, display the product uniques,
 * which are minor fit options like "with/without subwoofer".
 * Not all products have them.
 *
 * Some vehicles that use this:
 *
 * 2009 Ford F-150, Standard Cab [1 Pc Front]
 * 2016 Bentley Continental
 * 2024 Chevy Silverado 1500 Limited OldBodyStyle Crew Cab
 */
export default function ProductUniquePicker(props) {
  let {cartItem, callbacks} = props;
  let {lloydItem} = cartItem;

  let uniques = getProductUniquesList(lloydItem);

  if (_.isEmpty(uniques)) return null;

  let caption = camelOrSnakeField(lloydItem, 'package_content_description');

  return <div className="lloyd-product-unique-picker bg-white shadow-md pt-4 pb-2">

    <h4 className="text-brand-orange">
      <strong>{caption}</strong>:
      to ensure proper fit, please select:
    </h4>

    {
      uniques.map((u, i) =>
        <ProductUniqueOption
          key={u.brandApplicationCode || i}
          unique={u}
          cartItem={cartItem}
          callbacks={callbacks}
        />)
    }
  </div>
}
